import { FC, useContext, useMemo, } from 'react';
import { ProSelect } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import SearchFormDisabled from './subpage/disabled';
import { getSelectPlaceholder } from '../utils/ruleUtils';
import { DefaultOptionType, SelectProps } from 'antd/lib/select';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormSelectProps extends BaseSearchFormItemProps {
  /** select Props */
  selectProps?: SelectProps<any> & {
    options?: DefaultOptionType[] | (() => DefaultOptionType[]),
    /** 过滤options */
    filterOptions?: (options?: DefaultOptionType[]) => DefaultOptionType[];
  };
  /** 枚举名称 */
  enumCode?: string;
}
/** 下拉 */
export const SearchFormSelect: FC<SearchFormSelectProps> = props => {
  const {
    selectProps,
    enumCode,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  const { enumData } = useLayoutContext();
  const handleFilterOption = (inputValue: string | number, option: any) => {
    return option.label?.includes(inputValue);
  };
  const options: any[] | undefined = useMemo(() => {
    if (enumCode && enumData) {
      const newOptions = enumData[enumCode]?.items ?? [];
      // @ts-ignore
      if (selectProps?.filterOptions) return selectProps?.filterOptions(newOptions);
      return newOptions;
    }
    const propsOptions = selectProps?.options;
    if (typeof propsOptions === 'function') return propsOptions();
    if (selectProps?.filterOptions) return selectProps?.filterOptions(propsOptions);
    return propsOptions;
  }, [enumCode, selectProps?.options]);
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || selectProps?.disabled}
      name={name}
      label={label}
      rules={rules}
    >
      {isDetail || (selectProps && selectProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          options={options}
          render={render || disabledRender}
          isTable={isTable}
          copy={copy}
        />
      ) : (
        <ProSelect
          allowClear
          showSearch
          style={{ width: '100%' }}
          filterOption={handleFilterOption}
          test-id={`${testId}-${name}`}
          {...selectProps}
          placeholder={getSelectPlaceholder(label, selectProps, rules)}
          options={options}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormSelect.displayName = SearchFormItemEnum.SearchFormSelect;

export default SearchFormSelect;
